import type { Translations } from "../types";

const sv: Translations = {
  "meta.title": "Klick per land",
  "meta.description":
    "Interaktiv världskarta: gratis klick per land samt betalt stöd via Stripe, PayPal och Buy Me a Coffee.",

  "app.title": "Klick per land",

  "map.intro":
    "Klicka på ett land på kartan för att ge det en gratis röst, eller skicka ekonomiskt stöd - båda räknas till den kombinerade topplistan nedan. Kartan speglar endast stöd inom den här appen, inte faktisk nationell förmögenhet eller BNP.",
  "map.verifying": "Verifierar …",
  "map.confirmNotRobot": "Innan du kan lägga till gratis klick, bekräfta snabbt att du inte är en robot:",
  "map.tryAgain": "Försök igen",
  "map.registeringClick": "Registrerar klick …",
  "map.selectedCountry": "Valt land: {name}.",
  "map.selectFirstFeedback": "Land valt. För att lägga till ett gratis klick, bekräfta först nedan att du inte är en robot.",
  "map.verificationExpired": "Verifieringen har gått ut - bekräfta igen att du inte är en robot.",
  "map.slowDown": "Lite långsammare - vänta ett ögonblick innan nästa klick.",
  "map.clickFailed": "Kunde inte registrera klicket. Försök igen.",
  "map.clickErrorGeneric": "Fel vid registrering av klick.",
  "map.leaderboardHeading": "Topplista för länder",
  "map.emptySelection": "Välj ett land på kartan för att klicka på det eller stödja det.",
  "map.loadingData": "Läser in data …",

  "worldmap.loadError": "Kartan kunde inte läsas in.",
  "worldmap.resetZoom": "Återställ zoom",
  "worldmap.resetButton": "⤾ Återställ",
  "worldmap.loadingMap": "Läser in karta …",
  "worldmap.unknownCountry": "Okänt",
  "worldmap.ariaClicks": "{name}: {clicks} klick",
  "worldmap.tooltipClicks": "{clicks} klick",

  "legend.fewer": "Färre klick",
  "legend.more": "Fler klick",

  "list.empty": "Inga klick än. Bli den första!",
  "list.ariaLabel": "Topplista över länder efter antal klick",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY är inte inställd - se README för konfiguration.",
  "human.verificationFailedGeneric": "Verifieringen misslyckades.",
  "human.networkError":
    "Kunde inte nå verifieringen (nätverksfel) - kontrollera VITE_SUPABASE_URL, att verify-human är driftsatt, och ALLOWED_ORIGIN; se README/NAVODILA.",
  "human.verificationFailedRetry": "Verifieringen misslyckades, försök igen.",

  "provider.stripe": "💳 Kort (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Valt land",
  "panel.currentlyRanked": "Just nu rankad #{rank}",
  "panel.shareCopied": "Kopierat ✓",
  "panel.shareShared": "Delat ✓",
  "panel.shareButton": "🔗 Dela",

  "panel.tableClicks": "Klick",
  "panel.tableFree": "Gratis",
  "panel.tablePaid": "Betalt",
  "panel.rowAllTime": "Totalt",
  "panel.rowThisYear": "I år",
  "panel.rowThisWeek": "Denna vecka",
  "panel.rowToday": "Idag",

  "panel.totalCombined": "Totalt kombinerat:",
  "panel.totalSupport": "Totalt stöd:",

  "panel.paymentMethod": "Betalningsmetod",
  "panel.noPaymentMethod": "Ingen betalningsmetod är för närvarande tillgänglig.",
  "panel.supportAmount": "Stödbelopp (EUR)",
  "panel.amountRange": "Beloppet bör vara mellan {min} och {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Uppskattade betalda klick:",
  "panel.ratioInfo":
    "Förhållande: {a} = {b} klick (t.ex. {c} = {d} klick). Detta är endast en uppskattning före betalning - det slutgiltiga antalet klick beräknas och bekräftas alltid av servern utifrån den faktiskt bekräftade betalningen.",
  "panel.preparing": "Förbereder …",
  "panel.continueWith": "Fortsätt med {provider}",
  "panel.choosePaymentMethod": "Välj en betalningsmetod",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME är inte inställd - se README för konfiguration.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID är inte inställd - se README för konfiguration.",

  "panel.paypalAmountInfo": "Belopp: {amount} (uppskattat {clicks} klick). Slutför betalningen med PayPal-knappen nedan.",
  "panel.back": "← Tillbaka",

  "panel.bmcWarningTitle": "⚠️ Innan du fortsätter till BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Klistra in koden nedan i meddelande-/anteckningsfältet i kassan — det är enda sättet vi vet vilket land du stödjer. Utan koden kan vi inte koppla betalningen till något land.",
  "panel.copy": "Kopiera",
  "panel.copied": "Kopierat ✓",
  "panel.suggestedAmount": "Föreslaget belopp:",
  "panel.bmcAmountNote":
    "(uppskattat {clicks} klick). BuyMeCoffee stöder tyvärr inte att föra över beloppet via länk — ange/välj det själv på deras webbplats. Det faktiska antalet klick beräknas alltid utifrån det belopp du faktiskt skickar via BuyMeCoffee, inte utifrån den här uppskattningen.",
  "panel.openBmc": "Öppna BuyMeCoffee och fortsätt →",
  "panel.waitingProvider": "Väntar på betalningsbekräftelse från betalningsleverantören …",
  "panel.waitingConfirmation": "Väntar på betalningsbekräftelse …",
  "panel.timedOut":
    "Kontrollen tog för lång tid. Om du har slutfört betalningen uppdateras kartan så snart servern tar emot en bekräftelse - det kan ibland ta lite längre tid.",
  "panel.checkAgain": "Kontrollera igen",

  "panel.cancelled": "Betalningen avbröts eller genomfördes inte. Kartan har inte ändrats.",
  "panel.tryAgain": "Försök igen",

  "panel.confirmed": "✅ Stödet bekräftat!",
  "panel.confirmedBody": "{country} fick {clicks} betalda klick för {amount}.",

  "panel.errorPreparingSupport": "Fel vid förberedelse av ditt stöd.",
  "panel.errorPreparingPayment": "Fel vid förberedelse av betalning.",
  "panel.errorConfirmingPayment": "Fel vid bekräftelse av betalning.",
  "panel.errorPayingPaypal": "Fel vid betalning med PayPal.",

  "share.unranked": "{flag}{country} behöver ditt stöd på världskartan!\nHjälp landet att klättra i topplistan 👇",
  "share.rank1": "{flag}{country} ligger just nu på #1!\nHjälp oss stanna kvar i toppen 👇",
  "share.rankN": "{flag}{country} ligger just nu på #{rank}!\nHjälp oss nå #1 👇",

  "language.switcherLabel": "Språk",
};

export default sv;
